<script>
  import SectionHeading from "../shared/SectionHeading.svelte";
  import SkillCard from "../shared/SkillCard.svelte";
  import app from "../stores/app";
  import skills from "../stores/skills";
</script>

<style>
  .skills-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    column-gap: 25px;
  }

  @media (max-width: 550px) {
    .skills-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
      column-gap: 10px;
    }
  }
</style>

<div class="relative" id="skills">
  <div class="max-w-7xl mx-auto px-4 py-6 " id="my-work">
    {#if $app.lang === 'en'}
      <SectionHeading text1="MY" text2="SKILLS" />
    {:else}
      <SectionHeading text1="MON" text2="EXPERTISE" />
    {/if}

    <h1 class="text-center text-xl pb-10">
      {#if $app.lang === 'en'}
        <span>
          Here is a non exhaustive list of some of the tools I love to work
          with.
        </span>
      {:else}
        <span>
          Voici une liste non exhaustive des outils avec lesquels je travaille.
        </span>
      {/if}
    </h1>

    <div class="skills-grid mx-auto">
      {#each $skills as item (item.id)}
        <SkillCard {...item} />
      {/each}
    </div>
  </div>
</div>
